module.exports = __webpack_public_path__ + "static/media/PackageHoldLogo.aafc5851.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/PackageHoldLogo.png
// module id = 1062
// module chunks = 0